<template>
  <section>
    <div class="flex py-6">
      <a
        v-for="item in menu_buttons"
        @click="selectChoose(item)"
        :key="item.label"
        :class="
          item.active
            ? 'border-ontick-blue-500 text-ontick-steel-900 dark:text-gray-300'
            : 'dark:border-ontick-carbon-500 border-gray-50 text-gray-500'
        "
        class="md:text-made cursor-pointer border-b-2 px-3 py-2 text-sm md:px-6"
      >
        {{ item.label }}
      </a>
    </div>
    <div class="flex w-full py-2 md:w-3/4">
      <div class="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
        <treeselect
          :multiple="false"
          :options="investiment"
          :show-count="true"
          :searchable="false"
          :clearable="false"
          placeholder="Selecione seu investimento"
          v-model="select_investment_id"
          @select="selectInvestment"
        >
          <div
            slot="option-label"
            slot-scope="{ node, labelClassName }"
            :class="labelClassName"
            class="py-2"
          >
            <div
              class="flex items-center justify-between"
              v-for="(item, index) in list_investment"
              :key="index"
            >
              <div class="space-x-3" v-if="node.id == item.investment_id">
                <span
                  class="relative -mb-3 inline-flex h-3 w-3 items-center"
                  :content="
                    item.investment_status === 'STOPPED'
                      ? 'Investimento parado'
                      : item.investment_status === 'RUNNING'
                      ? 'Investimento em execução'
                      : 'Investimento arquivado'
                  "
                  v-tippy="{
                    arrow: true,
                    theme:
                      item.investment_status === 'STOPPED'
                        ? 'red'
                        : item.investment_status === 'RUNNING'
                        ? 'green'
                        : 'gray',
                  }"
                >
                  <span
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500 animate-ping'
                        : 'bg-gray-400'
                    "
                    class="absolute inline-flex h-full w-full rounded-full opacity-75"
                  ></span>

                  <span
                    class="relative inline-flex h-3 w-3 rounded-full"
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500'
                        : 'bg-gray-400'
                    "
                  ></span>
                </span>
                <span class="text-ontick-blue-500 inline-flex text-sm">{{
                  item.investment_id
                }}</span>
                <span
                  class="text-ontick-steel-900 text-sm dark:text-gray-300"
                  >{{ node.label }}</span
                >
              </div>
              <div
                class="text-ontick-steel-900 float-right ml-2 text-sm dark:text-gray-300"
                v-if="node.id == item.investment_id"
              >
                <div
                  content="Ordens executadas"
                  v-tippy="{ arrow: true, theme: 'green' }"
                  v-show="item.investment_status != 'HIDDEN'"
                  class="mx-2 inline-flex items-center"
                >
                  <p class="mx-2">{{ item.num_positions }}</p>
                </div>
              </div>
            </div>
          </div>
          <div slot="value-label" slot-scope="{ node }" class="w-full">
            <div
              class="flex items-center justify-between"
              v-for="(item, index) in list_investment"
              :key="index"
            >
              <div class="space-x-3" v-if="node.id == item.investment_id">
                <span
                  class="relative -mb-3 inline-flex h-3 w-3 items-center"
                  :content="
                    item.investment_status === 'STOPPED'
                      ? 'Investimento parado'
                      : item.investment_status === 'RUNNING'
                      ? 'Investimento em execução'
                      : 'Investimento arquivado'
                  "
                  v-tippy="{
                    arrow: true,
                    theme:
                      item.investment_status === 'STOPPED'
                        ? 'red'
                        : item.investment_status === 'RUNNING'
                        ? 'green'
                        : 'gray',
                  }"
                >
                  <span
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500 animate-ping'
                        : 'bg-gray-400'
                    "
                    class="absolute inline-flex h-full w-full rounded-full opacity-75"
                  ></span>

                  <span
                    class="relative inline-flex h-3 w-3 rounded-full"
                    :class="
                      item.investment_status == 'STOPPED'
                        ? 'bg-ontick-red-500'
                        : item.investment_status == 'RUNNING'
                        ? 'bg-ontick-green-500'
                        : 'bg-gray-400'
                    "
                  ></span>
                </span>
                <span class="text-ontick-blue-500 inline-flex text-sm">{{
                  item.investment_id
                }}</span>
                <span
                  class="text-ontick-steel-900 text-sm dark:text-gray-300"
                  >{{ node.label }}</span
                >
              </div>
              <div
                class="text-ontick-steel-900 float-right ml-2 text-sm dark:text-gray-300"
                v-if="node.id == item.investment_id"
              >
                <div
                  content="Ordens executadas"
                  v-tippy="{ arrow: true, theme: 'green' }"
                  v-show="item.investment_status != 'HIDDEN'"
                  class="mx-2 inline-flex items-center"
                >
                  <p class="text-ontick-steel-900 mx-2 dark:text-gray-300">
                    {{ item.num_positions }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </treeselect>
        <div class="relative">
          <VueCtkDateTimePicker
            id="performance-datepicker"
            class="performance-datepicker"
            v-model="calendarSelected"
            label="Selecione o periodo"
            :range="range"
            :dark="getUiTheme === 'DARK' ? true : false"
            :only-date="true"
            locale="pt-BR"
            :noClearButton="true"
            :no-button-now="true"
            :custom-shortcuts="customShortcuts"
            :max-date="moment().format('YYYY-MM-DD')"
            :disabled-weekly="[0, 6]"
            formatted="D MMM YYYY"
            @validate="dateSelected(calendarSelected)"
            :no-value-to-custom-elem="true"
          >
          </VueCtkDateTimePicker>
          <span class="absolute inset-y-2.5 right-2" v-html="$icons.calendar" />
        </div>
      </div>

      <button
        @click="update()"
        content="Atualizar dados"
        v-tippy="{ arrow: true, theme: 'green' }"
        class="text-ontick-blue-500 relative col-span-1 ml-2 hidden w-10 items-center py-2 md:inline-flex md:px-2"
      >
        <span
          v-html="active_update ? update_icon.active : update_icon.disabled"
        ></span>
      </button>
    </div>
  </section>
</template>

<script>
// const customShortcuts = [
//   { key: "thisDay", label: "Hoje", value: "day" },
//   { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
//   { key: "lastWeek", label: "Semana anterior", value: "-isoWeek" },
//   { key: "last7Days", label: "Últimos 7 dias", value: 7 },
//   { key: "last30Days", label: "Últimos 30 dias", value: 30 },
//   { key: "thisMonth", label: "Esse mês", value: "month" },
//   { key: "lastMonth", label: "Mês anterior", value: "-month" },
//   { key: "thisYear", label: "Esse ano", value: "year" },
//   { key: "lastYear", label: "Ano anterior", value: "-year" },
//   {
//     key: "last365Days",
//     label: "Últimos 365 dias",
//     value: () => {
//       return {
//         start: moment().subtract(365, "days"),
//         end: moment(),
//       };
//     },
//   },
// ];
import { mapActions, mapGetters, mapState } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "performance-investment",
  components: {
    Treeselect,
    VueCtkDateTimePicker,
    menuMobile: () => import("./investiment.mobile.component"),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    chart: { type: Boolean, default: false },
  },
  data() {
    return {
      active_update: false,
      update_icon: {
        active: `<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
        disabled: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
      },
      customShortcuts: [
        { key: "thisDay", label: "Hoje", value: "day" },
        { key: "thisWeek", label: "Essa semana", value: "isoWeek" },
        { key: "lastWeek", label: "Semana anterior", value: "-isoWeek" },
        { key: "last7Days", label: "Últimos 7 dias", value: 7 },
        { key: "last30Days", label: "Últimos 30 dias", value: 30 },
        { key: "thisMonth", label: "Esse mês", value: "month" },
        { key: "lastMonth", label: "Mês anterior", value: "-month" },
        { key: "thisYear", label: "Esse ano", value: "year" },
        { key: "lastYear", label: "Ano anterior", value: "-year" },
        {
          key: "last365Days",
          label: "Últimos 365 dias",
          value: () => {
            return {
              start: this.moment().subtract(365, "days"),
              end: this.moment(),
            };
          },
        },
      ],
      date_logs: {
        max: "",
        min: "",
      },
      select_period: {},
      select_date: null,
      investiment: [],
      list_investment: [],
      select_investment: {},
      select_investment_id: null,
      buttons: "py-2 px-2 rounded text-white w-full",
      menu_buttons: [
        {
          label: "Resumo",
          active: true,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path></svg>`,
        },
        {
          label: "Ordens",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>`,
        },

        {
          label: "Gráficos",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>`,
        },
        {
          label: "Logs",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>`,
        },
      ],
      data_account: [],
      save_date: {},
      range: true,
    };
  },

  created() {
    this.initListInvestment(this.data);
  },
  methods: {
    ...mapActions({
      toggleAccount: "performance/toggleAccount",
    }),

    initListInvestment(value) {
      let investiment_array = [];
      let order_by = { stopped: [], running: [], hidden: [] };
      this.select_period.start = this.dateCurrent();
      this.select_period.end = this.dateCurrent("end");

      value.accounts.forEach((item_account) => {
        item_account.investments.forEach((item) => {
          investiment_array.push(item);
          let new_investment;
          if (item.investment_status == "STOPPED") {
            new_investment = {
              label: item.investment_name,
              id: item.investment_id,
            };

            order_by.stopped.push(new_investment);
          } else if (item.investment_status == "RUNNING") {
            new_investment = {
              label: item.investment_name,
              id: item.investment_id,
            };

            order_by.running.push(new_investment);
          } else {
            new_investment = {
              label: item.investment_name,
              id: item.investment_id,
            };

            order_by.hidden.push(new_investment);
          }
        });
      });

      this.investiment = order_by.running.concat(
        order_by.stopped,
        order_by.hidden
      );

      if (Object.keys(this.$route.params).length == 0) {
        this.select_investment = this.investiment[0];
        this.select_investment_id = this.investiment[0].id;
      } else {
        this.select_investment_id = this.$route.params.id;
        this.select_investment = {
          id: this.$route.params.id,
          label: this.$route.params.label,
        };

        if (this.$route.params.type == "logs") {
          this.$emit("activeLogs", true);
        }
      }

      this.list_investment = investiment_array;

      this.selectInvestment(this.select_investment);
    },

    dateCurrent(value) {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today =
        value == "end"
          ? yyyy + "-" + mm + "-" + dd + "T" + "23:59:59"
          : yyyy + "-" + mm + "-" + dd + "T" + "00:00:00";

      return today;
    },

    selectChoose(value) {
      this.menu_buttons.forEach((item) => {
        item.active = false;
      });
      value.active = true;
      this.$emit("chooseItem", value);
    },

    selectInvestment(investment) {
      this.select_investment = investment;
      this.dateSelected(this.calendarSelected);
    },

    dateSelected(selected_date) {
      let date = {};

      if (selected_date.hasOwnProperty("start")) {
        if (this.isIsoDate(selected_date.start + ".000Z")) {
          date = selected_date;
        } else {
          date.end =
            selected_date.end == null
              ? selected_date.start.split(" ")[0] + "T" + "23:59:59"
              : selected_date.end.split(" ")[0] + "T" + "23:59:59";
          date.start = selected_date.start.split(" ")[0] + "T" + "00:00:00";
        }
      } else {
        if (this.isIsoDate(selected_date + ".000Z")) {
          date.end = selected_date.split(" ")[0];
        } else {
          date.end = selected_date.split(" ")[0] + "T" + "23:59:59";
        }
      }
      let data_investment = {};

      let index = this.list_investment.findIndex(
        (item) => item.investment_id == this.select_investment.id
      );
      if (index != -1) {
        data_investment = this.list_investment[index];
      }

      let params = {
        investment: data_investment,
        date_range: date,
        range: this.range,
      };
      this.$emit("listInvestment", params);
    },

    isIsoDate(str) {
      if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
      var d = new Date(str);
      return d.toISOString() === str;
    },

    update() {
      this.active_update = true;
      setTimeout(() => {
        this.active_update = false;
      }, 1000);

      this.$swal({
        titleText: `Dados atualizados `,
        icon: "success",
        toast: true,
        position: "top-end",
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
        customClass: {
          popup: "sweetalert_popup",
          title: "sweetalert_title_toast",
          confirmButton: "sweetalert_confirm_button",
          content: "sweetalert_popup_toast",
          backdrop: "swal2-backdrop-hide",
        },
      });

      this.dateSelected(this.calendarSelected);
    },
  },

  computed: {
    ...mapState({
      user_code: (state) => state.config.user_code,
    }),
    ...mapGetters({ getUiTheme: "config/getUiTheme" }),

    calendarSelected: {
      get() {
        if (this.range) {
          return this.select_period;
        } else {
          this.select_date =
            this.select_date == null
              ? this.select_period.end
              : this.select_date;
          return this.select_date;
        }
      },
      set(val) {
        if (this.range) {
          this.select_period = val;
          this.select_date = val.end;
        } else {
          this.select_date = val;
        }
      },
    },
  },

  watch: {
    data(value) {
      this.initListInvestment(value);
      return value;
    },
    chart(val) {
      if (val) {
        this.customShortcuts = [];
        this.range = false;
      } else {
        // this.customShortcuts = customShortcuts;
        this.range = true;
      }
    },

    menu_buttons: {
      deep: true,
      handler(val) {
        if (val[0].active || val[1].active) {
          this.dateSelected(this.calendarSelected);
        }
      },
    },
  },

  unmounted: function () {
    this.investiment = [];
  },
};
</script>

<style lang="scss">
@import "./investment.component.scss";
</style>
